module.exports = __webpack_public_path__ + "img/akfel-wgc-paris-multitouch-application-06.18cd44d6.jpg";